import './frontend.css';

if (document.querySelector('.swiper.stock-carousel')) {
    import('./swiper');
}
